<template>
    <v-snackbar
        v-model="snackOpen"
        :color="snackColor"
        top
        content-class="pr-0"
    >
        <v-row>
            <v-col cols="9" class="d-flex align-center">
                <span class="caption pr-4">{{ snackText }}</span>
            </v-col>
            <v-col cols="3" class="d-flex pl-0 justify-end">
                <v-btn v-if="snackDelete" text class="text--main-yellow px-0 ml-0" @click="$emit('remove')">{{ $t('yes') }}</v-btn>
                <v-btn icon @click="snackOpen = false" class="grey--text">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-snackbar>
</template>

<script>

export default {
    name: "SnackWithDelete",
    props: ['snackColor', 'isOpen', 'snackDelete', 'snackText'],
    computed: {
        snackOpen: {
            get() {
                return this.isOpen;
            },
            set(value) {
                if(!value) {
                    this.$emit('close-snack');
                }
            }
        }
    },
}
</script>

<style scoped>

</style>
